"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgSharedToilet = function SvgSharedToilet(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.5 15.504v.081c0 2.2 1.783 3.982 3.982 3.982m3.035-.037a3.971 3.971 0 0 0 3.97-3.97v-.056",
    stroke: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.498 19.51a1.94 1.94 0 0 0-1.94 1.94v.064h2.018m2.941-1.966h.069c1.08 0 1.957.876 1.957 1.957h-2.026M12 1.086v21.848",
    stroke: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.71 13.473c.949-1.217 1.535-2.89 1.535-4.738 0-3.022-1.568-5.58-3.728-6.432m-3.035-.046c-2.222.803-3.85 3.4-3.85 6.478 0 1.846.586 3.52 1.535 4.736",
    stroke: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.307 5.022c-.976.74-1.634 2.126-1.634 3.713 0 1.634.697 3.054 1.722 3.777m3.13-.03c1.002-.733 1.68-2.136 1.68-3.747 0-1.627-.692-3.043-1.71-3.769",
    stroke: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.576 13.5h-4.01a1 1 0 0 0-1 1v.004a1 1 0 0 0 1 1h4.01m2.919-2.004h4.037a1 1 0 0 1 1 1v.004a1 1 0 0 1-1 1h-4.037",
    stroke: "#4D4D4D"
  })));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgSharedToilet);
var _default = exports["default"] = Memo;